import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {InputSwitch} from "primereact/inputswitch";

const PartnerAddressFormComponent = (props) => {

  const {t, partnerId, partnerType} = props;
  const history = useHistory();
  const {module, entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [addressTypes, setAddressTypes] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const partnerAddressId = props.partnerAddressId || window.App.urlVars().partnerAddressId || (entity === 'partner-address' ? id : null);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if (partnerAddressId) {
      const payload = {
        ...data,
        ...formData,
        ...newFormData,
      }
      apiCall('patch', '/api/v2/partner-address/' + partnerAddressId, payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderPartnerAddressList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      const payload = {
        ...formData,
        ...newFormData,
        ...(partnerId ? { partner: partnerId } : {}),
      }
      apiCall('post', '/api/v2/partner-address', payload)
        .then(response => {
          window.App.toastShow('success', t('toastSaveSuccess'));
          window.App.setState({rerenderPartnerAddressList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push(`/partner/read/${partnerId}/partner-address/update/${response.data.data.id}`);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  const isResidenceAddressType = (type) => {
    const key = (type?.key || '').toString().toLowerCase();
    const value = (type?.value || '').toString().toLowerCase();
    return key.includes('lakohely')
      || key.includes('lakóhely')
      || value.includes('lakohely')
      || value.includes('lakóhely');
  };

  const isSiteAddressType = (type) => {
    const key = (type?.key || '').toString().toLowerCase();
    const value = (type?.value || '').toString().toLowerCase();
    return key.includes('telephely')
      || key.includes('fioktelep')
      || key.includes('fióktelep')
      || value.includes('telephely')
      || value.includes('fioktelep')
      || value.includes('fióktelep');
  };

  const filteredAddressTypes = addressTypes.filter(type => {
    if (isResidenceAddressType(type)) {
      return partnerType === 'PERSON';
    }
    if (isSiteAddressType(type)) {
      return partnerType === 'ORGANISATION';
    }
    return true;
  });

  useEffect(() => {
    const selectedType = addressTypes.find(type => type.key === formData.addressType);
    if (!selectedType) {
      return;
    }
    if (isResidenceAddressType(selectedType) && partnerType !== 'PERSON') {
      setFormData(prev => ({
        ...prev,
        addressType: ''
      }));
      return;
    }
    if (isSiteAddressType(selectedType) && partnerType !== 'ORGANISATION') {
      setFormData(prev => ({
        ...prev,
        addressType: ''
      }));
    }
  }, [partnerType, addressTypes, formData.addressType]);

  useEffect(() => {
    apiCall('get', '/api/v2/dictionary/partner-address-type')
      .then(response => {
        setAddressTypes(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      });
    apiCall('get', "/api/v2/country")
      .then(response => {
        const countryOptions = Array.isArray(response.data)
          ? response.data
          : Array.isArray(response.data?.data)
            ? response.data.data
            : [];

        setCountries(countryOptions);
        if (!id) {
          const defaultCountry = process.env.REACT_APP_DEFAULT_COUNTRY;
          setFormData(prev => ({
            ...prev,
            address_country_code: prev.address_country_code ?? defaultCountry
          }));
        }
      })
      .catch(error => {
          console.log(error);
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if (partnerAddressId) {
      setLoading(true);
      apiCall('get', '/api/v2/partner-address/' + partnerAddressId)
        .then(response => {
          // setFormData(response.data.data)
          const d = response.data.data;
          setFormData({
            ...d,
            addressCountryCode: d.addressCountryCode ?? d.address_country_code ?? '',
            addressPostalCode: d.addressPostalCode ?? d.address_postal_code ?? '',
            addressCity: d.addressCity ?? d.address_city ?? '',
            addressDetail: d.addressDetail ?? d.address_detail ?? '',
            addressType: d.addressType ?? d.address_type ?? '',
            note: d.note ?? ''
          })
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [partnerAddressId]);

  return (
    <div className={"partner-address-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="addressType" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="addressType"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressType')}</label>
                  <span className="p-d-block">
                      <Dropdown id="addressType"
                                  options={filteredAddressTypes}
                                  optionLabel="value"
                                  optionValue="key"
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      addressType: e.value
                                    })
                                  }}
                                  value={formData.addressType}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-3"}>
              <Field name="addressCountryCode" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="addressCountryCode"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressCountry')}</label>
                  <span className="p-d-block">
                      <Dropdown id="addressCountryCode" {...input}
                                  options={countries}
                                  optionLabel="name"
                                  optionValue="code"
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      addressCountryCode: e.target.value
                                    })
                                  }}
                                  value={formData.addressCountryCode}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-2"}>
              <Field name="addressPostalCode" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="addressPostalCode"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressPostalCode')}</label>
                  <span className="p-d-block">
                      <InputText id="addressPostalCode" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      addressPostalCode: e.target.value
                                    })
                                  }}
                                  value={formData.addressPostalCode}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            
            <div className={"p-col-12 p-lg-3"}>
              <Field name="addressCity" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="addressCity"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCity')}</label>
                  <span className="p-d-block">
                      <InputText id="addressCity" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      addressCity: e.target.value
                                    })
                                  }}
                                  value={formData.addressCity}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            
            <div className={"p-col-12 p-lg-4"}>
              <Field name="addressDetail" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="addressDetail"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldAddressDetail')}</label>
                  <span className="p-d-block">
                      <InputText id="addressDetail" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      addressDetail: e.target.value
                                    })
                                  }}
                                  value={formData.addressDetail}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-8"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldNote')}</label>
                  <span className="p-d-block">
                      <InputText id="note" {...input}
                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      note: e.target.value
                                    })
                                  }}
                                  value={formData.note}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>

            <div className={"p-col-12 p-lg-4"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                          className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}
                                    checked={formData.active}

                                  onChange={(e) => {
                                    setFormData({
                                      ...formData,
                                      active: e.target.value
                                    })
                                    setNewFormData({
                                      ...newFormData,
                                      active: e.target.value
                                    })
                                  }}
                                  value={formData.active}
                                  className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'partner-address' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(PartnerAddressFormComponent);
